const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/ECheckinForm.tsx';
import React, { forwardRef } from 'react';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/uster/eCheckin/sections/PersAngaben';
import Hausarzt from 'App/config/uster/eCheckin/sections/Hausarzt';
import EinwArzt from 'App/config/uster/eCheckin/sections/EinwArzt';
import Versicherung from 'App/config/uster/eCheckin/sections/Versicherung';
import KontaktPerson from 'App/config/uster/eCheckin/sections/KontaktPerson';
import Behandlungsvereinbarung from 'App/config/uster/eCheckin/sections/Behandlungsvereinbarung';
import textMap from 'App/config/uster/eCheckin/translations';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';
import Finalize from 'App/components/eCheckin/components/sections/Finalize';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.personalData} />
            <KontaktPerson path="kontakt" title={textMap.contact} />
            <Hausarzt path="hausArzt" title={textMap.familyDoctor} />
            <EinwArzt path="einwArzt" title={textMap.instructionDoctor} />
            <Versicherung path="versicherung" title={textMap.insurance} />
            <Behandlungsvereinbarung path="behandlungsvereinbarung" title={textMap.costsAndConsent} />
            <Finalize path="finalize" />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
